module.exports = __webpack_public_path__ + "static/media/HomeRunBingoLand.6c17191e.png";